import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { FormSection } from '../../../../components/FormSection';
import { IconButton } from '../../../../components/IconButton';
import { ReactComponent as TrashIcon } from '../../../../assets/icons/cross-in-circle.svg';

const errors = 'pages.products.productConfigurator.formItems.district.errors';
const label = 'pages.products.productConfigurator.formItems.district.label';

type Props = {
  name: number;
  remove: (arg: number | number[]) => void;
};

export const DistrictRow: FC<Props> = ({ name, remove }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.space}>
      <FormSection
        className={styles.formSection}
        formItemProps={{
          hasFeedback: true,
          name,
          rules: [{ required: true, message: t(`${errors}.empty`) }],
        }}
        textFieldProps={{ type: 'string', label: t(label) }}
      />
      <div className={styles.trashButton}>
        <IconButton onClick={() => remove(name)} icon={<TrashIcon className={styles.trashIcon} />} />
      </div>
    </div>
  );
};
